import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { getApiErrorMessage, startFanvueSignupOAuth } from '../../api'
import PublicSiteShell from '../../components/v2/PublicSiteShell'
import '../../styles/admin-v2.css'
import { rememberFanvueOAuthSession } from './fanvueOAuthState'

export default function AdminV2PublicFanvueConnect() {
  const [state, setState] = useState({ busy: false, authUrl: '', message: '', error: '' })

  async function handleConnect() {
    setState({ busy: true, authUrl: '', message: 'Creating secure Fanvue connection...', error: '' })
    try {
      const result = await startFanvueSignupOAuth()
      const authUrl = result?.auth_url || result?.authUrl || ''
      const oauthState = result?.state || ''
      rememberFanvueOAuthSession({ state: oauthState, authUrl, source: 'signup' })
      if (authUrl) {
        window.location.assign(authUrl)
      } else {
        setState({ busy: false, authUrl: '', message: '', error: 'Fanvue did not return an OAuth URL.' })
      }
    } catch (err) {
      setState({ busy: false, authUrl: '', message: '', error: getApiErrorMessage(err, 'Failed to start Fanvue signup') })
    }
  }

  return (
    <PublicSiteShell>
      <section className="v2-public-connect">
        <div className="v2-public-copy">
          <p className="v2-kicker">Fanvue connection</p>
          <h1>Connect your Fanvue account</h1>
          <p>
            Approve access on Fanvue to create your private FanLTV workspace. Automation stays paused until you review the settings and enable it.
          </p>
        </div>

        <div className="v2-public-permissions" aria-label="Requested access summary">
          <strong>Access used by FanLTV</strong>
          <span>Chats for inbox replies</span>
          <span>Fans for conversation context</span>
          <span>Media for attachments you choose to send</span>
        </div>

        <div className="v2-public-actions">
          <button type="button" className="v2-button" disabled={state.busy} onClick={handleConnect}>
            {state.busy ? 'Opening Fanvue...' : 'Connect Fanvue'}
          </button>
          <Link className="v2-button v2-button-quiet" to="/login">Sign in</Link>
        </div>

        <ol className="v2-public-steps">
          <li>Open the secure Fanvue authorization page.</li>
          <li>Review and approve the requested permissions.</li>
          <li>Return automatically and finish setup with the bot paused.</li>
        </ol>

        <div className="v2-feedback-stack" aria-live="polite">
          {state.message ? <div className="v2-success">{state.message}</div> : null}
          {state.error ? <div className="v2-error">{state.error}</div> : null}
          {state.authUrl ? <a className="v2-text-link" href={state.authUrl}>Open OAuth link</a> : null}
        </div>
      </section>
    </PublicSiteShell>
  )
}
